import { render } from "./Guide.vue?vue&type=template&id=f213ee56"
import script from "./Guide.vue?vue&type=script&lang=js"
export * from "./Guide.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__